import { useRef } from 'react';

export function useDebounce() {
    const timeout = useRef<NodeJS.Timeout>();
    return (callback: (...args: any[]) => void, ms?: number | undefined, ...args: any[]) => {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(callback, ms, ...args);
    };
}
